<template>
  <div class="page">
    <Header title="活动画廊用户投稿" />
    <van-cell-group>
      <van-field v-model="submissionInfo.clientCode" label="易加编号" center clearable placeholder="请填写易加编号" />
      <van-cell class="client-code-tip" value="使用易加编号投稿者一旦稿件被采纳可获得积分或礼券奖励" />
      <van-field v-model="submissionInfo.eventName" label="活动名称" center clearable placeholder="请填写活动名称" />
      <van-cell title="活动日期" is-link v-model="submissionInfo.eventTime" @click="showDateTimeSelector" />
      <van-field v-model="submissionInfo.eventLocation" label="活动地点" center clearable placeholder="请填写活动地点" />
      <van-field v-model="submissionInfo.involveDealer" label="参与经销商" center clearable placeholder="请填写参与经销商" />
      <van-field v-model="submissionInfo.targetCustomer" label="目标客户" center clearable placeholder="请填写目标客户" />
      <van-field v-model="submissionInfo.eventDesc" label="活动说明" type="textarea" rows="1" autosize center clearable placeholder="请填写活动说明" />
      <van-cell title="活动图片" is-link>
        <van-uploader :before-read="beforeImageRead" :after-read="afterImageRead">
          <van-icon name="photograph" /> 点击上传图片
        </van-uploader>
      </van-cell>
    </van-cell-group>
    <van-row>
      <van-col v-for="(file, index) in fileList" :key="index" span="8">
        <div class="upload-image">
          <img :src="file.content" @click="previewImage(index)" />
        </div>
        <div class="image-delete-btn">
          <van-button type="danger" size="small" @click="removeImage(index)">删除</van-button>
        </div>
      </van-col>
    </van-row>

    <div class="button-line">
      <van-button type="primary" size="large" @click="submit">提交投稿</van-button>
    </div>
    <DateTimeSelector ref="date-selector" v-model="submissionInfo.eventTime" mode="date" />
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import Header from '@/components/header'
import DateTimeSelector from '@/components/date-time-selector'
import galleryApi from '@/api/gallery'
import fileApi from '@/api/file'
import Compress from 'compress.js'
import { commonUtils } from '@/utils/common'
export default {
  name: 'GallerySubmission',
  components: {
    Header,
    DateTimeSelector
  },
  data () {
    return {
      submissionInfo: {
        clientCode: '',
        eventName: '',
        eventTime: '',
        eventLocation: '',
        involveDealer: '',
        targetCustomer: '',
        eventDesc: ''
      },
      fileList: [],
      imageCountLimit: 9,
      imageSizeLimit: 5 * 1024 * 1024,
      photoList: []
    }
  },
  computed: {
    imageList () {
      const images = []
      this.fileList.map(file => {
        images.push(file.content)
      })
      return images
    }
  },
  methods: {
    showDateTimeSelector () {
      this.$refs['date-selector'].show()
    },

    beforeImageRead (file) {
      if (this.fileList.length >= 9) {
        this.$toast('一次最多可上传9张图片')
        return false
      }
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$toast('请上传JPG或PNG图片')
        return false
      }
      return true
    },
    afterImageRead (file) {
      if (file.file.size < 1024 * 1024) {
        this.fileList.push(file)
      } else {
        const compress = new Compress()
        compress.compress([file.file], {
          size: 4,
          quality: 0.75,
          maxWidth: 2000,
          maxHeight: 2000,
          resize: true
        }).then(results => {
          // console.log(results)
          const img = results[0]
          const base64Str = img.prefix + img.data
          const fileObj = commonUtils.convertBase64ToFile(base64Str, file.file.name)
          const compressedFile = {
            content: base64Str,
            file: fileObj
          }
          if (compressedFile.file.size > this.imageSizeLimit) {
            this.$toast('上传图片不能大于5M')
          } else {
            this.fileList.push(compressedFile)
          }
        })
      }
    },
    previewImage (index) {
      ImagePreview({
        images: this.imageList,
        startPosition: index
      })
    },
    removeImage (index) {
      this.fileList.splice(index, 1)
    },

    submit () {
      if (!this.checkData()) {
        return
      }
      this.photoList = []
      const uploadPromises = []
      this.fileList.map((file, index) => {
        uploadPromises.push(this.uploadImage(file.file, index))
      })
      Promise.all(uploadPromises).then(() => {
        this.submitData()
      })
    },

    checkData () {
      if (!this.submissionInfo.eventName) {
        this.$dialog.alert({ message: '请填写活动名称' })
        return false
      }
      if (this.fileList.length === 0) {
        this.$dialog.alert({ message: '请选取投稿图片' })
        return false
      }
      return true
    },

    uploadImage (fileData, index) {
      return new Promise((resolve, reject) => {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          mask: true,
          message: '上传图片' + (index + 1)
        })
        fileApi.uploadFilePublic(fileData).then(response => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.photoList.push({
              photoFileId: response.data.resultData.fileDTO.fileId
            })
          }
          resolve()
        }).catch((error) => {
          this.$toast.clear()
          reject(error)
        })
      })
    },

    submitData () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '正在提交投稿'
      })
      const payload = {
        submissionInfo: this.submissionInfo,
        photoList: this.photoList
      }
      galleryApi.createGallerySubmission(payload).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$dialog.alert({ message: '投稿信息提交成功' }).then(() => {
            this.$router.replace('/gallery/category')
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }

}
</script>

<style lang="less" scoped>
.client-code-tip {
  /deep/ .van-cell__value--alone {
    color: #cdcdcd;
    font-size: 12px;
  }
}

.upload-image {
  text-align: center;
  height: 60px;
  margin: 10px 0 10px 0;
  img {
    max-width: 80%;
    max-height: 60px;
  }
}
.image-delete-btn {
  margin: 5px;
  text-align: center;
}

.button-line {
  padding: 20px;
}
</style>
